import React from 'react';
interface SectionDividerProps {
  label: string;
}
export function SectionDivider({
  label
}: SectionDividerProps) {
  return <div className="flex items-center my-16 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-480">
      <div className="flex-1 border-t border-slate-200" data-id="element-481"></div>

      <div className="flex items-center justify-center" data-id="element-482">
        <div className="border-t border-slate-200 flex-1" data-id="element-483"></div>

        <span className="px-6 font-medium text-gold uppercase" data-id="element-484">{label}</span>
        <div className="flex-1 border-t border-slate-200" data-id="element-485"></div>
      </div>
    </div>;
}